import { Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import MapView from './components/Map';
import Home from './Home';
import { useUserContext } from './contexts/UserContext';
import Loading from './components/Loading';
import MobileRedirect from './components/MobileRedirect';

export default function App() {
  const {
    user,
    setUser,
    isLoading
  } = useUserContext();
  
  // Show loading spinner while checking authentication
  if (isLoading) {
    return <Loading />;
  }
  
  return (
    <div className="App">
      <MobileRedirect />
      <Routes>
        <Route path='/login' element={<Home user={user} setUser={setUser} />}></Route>
        // Removed session_id route - no longer needed
        {/* <Route path='/signup/:id' element={<Home user={user} setUser={setUser} />}></Route> */}
        <Route path='/' element={<Navigate replace to={user ? '/home' : '/login'}/>}></Route>
        {user && <Route exact path='/home' element={<MapView user={user} setUser={setUser}/>}></Route>}
        <Route path='*' element={<Home user={user} setUser={setUser} />}></Route>
      </Routes> 
    </div>   
  );
}
